// estados.js — mapeo de texto de estado -> tono de color, COMÚN para toda la
// app (Gestionar, Rutas, Administración). Un mismo significado (ok/en curso/
// pendiente/problema) siempre se pinta igual, venga de donde venga el texto.
const TONOS = {
  // problema / requiere atención -> rojo
  perdida: "red", perdidas: "red", "no disponible": "red", baja: "red", bajas: "red",

  // prestada (la llave está fuera) -> amarillo, en TODA la app
  prestada: "amber", prestadas: "amber",

  // en curso / apartada sin entregar -> azul
  preparado: "blue", preparada: "blue", en_preparacion: "blue", "por entregar": "blue",

  // a la espera de que alguien actúe -> ámbar
  pedido: "amber", pendiente: "amber",

  // cerrado sin problema -> verde
  devuelta: "green", entregado: "green", entregada: "green", activo: "green", activos: "green", activas: "green",

  // sin más información -> gris
  recibidas: "gray",
};

export function tonoEstado(estado) {
  const k = String(estado ?? "").trim().toLowerCase();
  return TONOS[k] || "gray";
}

// Solo para los pocos valores que no se leen bien tal cual (con "_" o
// abreviados); el resto de estados (pedido/preparado/entregado/prestada/...)
// ya son palabras normales en español y se muestran tal cual vienen.
const ETIQUETAS = { en_preparacion: "en preparación" };
export function etiquetaEstado(estado) {
  const k = String(estado ?? "").trim().toLowerCase();
  return ETIQUETAS[k] || estado;
}
